<div class="top">
  <button mat-icon-button
          aria-label="Current task list" title="Current task list"
          routerLink="/current">
    <mat-icon>check</mat-icon>
  </button>
  <button mat-icon-button
          aria-label="Edit task" title="Edit task"
          routerLink="/edit-task/{{task.id}}">
    <mat-icon>edit</mat-icon>
  </button>

  <h1>Task Details</h1>
  <dl [hidden]="!dataLoaded">
    <dt>Id:</dt><dd>{{task.id}}</dd>
    <dt>Title:</dt><dd>{{task.title}}</dd>
    <dt>State:</dt><dd><app-task-state-label [taskState]="task.taskState"></app-task-state-label></dd>
    <dt>Creator:</dt><dd>{{task.creator}}</dd>
    <dt>Creation Time:</dt><dd>{{creationTime}}</dd>
  </dl>

  <div *ngIf="task.isCurrentSprint">
    This task is on the current sprint.
  </div>

  <div *ngIf="task.previousSprintsList.length > 0">
    <h2>Previous Sprints</h2>
    <ul>
      <li *ngFor="let sprintId of task.previousSprintsList">
        <a routerLink="/sprint/{{sprintId}}">
          {{ getSprintName(sprintId) | async }}
        </a>
      </li>
    </ul>
  </div>

  <div [hidden]="dataLoaded">
    <mat-spinner></mat-spinner>
  </div>
</div>
